import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const flags = [
  {
    country: 'Kenya',
    flag: 'https://flagcdn.com/w160/ke.png',
  },
  {
    country: 'Tanzania',
    flag: 'https://flagcdn.com/w160/tz.png',
  },
  {
    country: 'Uganda',
    flag: 'https://flagcdn.com/w160/ug.png',
  },
  {
    country: 'Rwanda',
    flag: 'https://flagcdn.com/w160/rw.png',
  },
  {
    country: 'Ethiopia',
    flag: 'https://flagcdn.com/w160/et.png',
  },
  {
    country: 'Nigeria',
    flag: 'https://flagcdn.com/w160/ng.png',
  },
  {
    country: 'South Africa',
    flag: 'https://flagcdn.com/w160/za.png',
  },
  {
    country: 'Egypt',
    flag: 'https://flagcdn.com/w160/eg.png',
  },
  {
    country: 'Morocco',
    flag: 'https://flagcdn.com/w160/ma.png',
  },
  {
    country: 'Ghana',
    flag: 'https://flagcdn.com/w160/gh.png',
  },
];

function FlagsCarousel() {
  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={3}
      slidesPerView={5}
      loop={true}
      autoplay={{
        delay: 2500,
        disableOnInteraction: false,
      }}
      breakpoints={{
        320: {
          slidesPerView: 3,
          spaceBetween: 5,
        },
        640: {
          slidesPerView: 4,
          spaceBetween: 5,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 5,
        },
      }}
    >
      {flags.map((flag, index) => (
        <SwiperSlide key={index}>
          <div className="group relative w-16 h-16 mx-auto">
            <div className="w-full h-full p-[2px] bg-white rounded-full flex items-center justify-center">
              <div className="w-full h-full rounded-full overflow-hidden">
                <img
                  src={flag.flag}
                  alt={`${flag.country} flag`}
                  className="w-full h-full object-cover object-center rounded-full filter grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              </div>
            </div>
            <p className="text-center mt-1 text-[10px] text-gray-600 truncate">{flag.country}</p>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default FlagsCarousel;